import Main from '@/views/administracion/configuracion/Main.vue';
import Default from '@/views/administracion/configuracion/Default.vue';
import Catalogos from './catalogos';

const auth = ['Configuración:ver'];
const scopes = ['Configuración:crear', 'Configuración:editar', 'Configuración:eliminar'];

const configuracion = [
  {
    path: 'configuracion',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'configuracion',
        path: '/',
        meta: {
          title: 'Configuración',
          auth,
          scopes,
        },
        component: Default,
        children: [],
      },
      ...Catalogos,
    ],
  },
];

export default configuracion;
